import { ref, computed } from "vue";
import { useScrollStore } from "@/stores/storeScroll";

export const isOIS = ref(false);
export const isIphone = ref(false);
export const isAddHeight = ref(false);

const getAgentSystem = () => {
	if (typeof window === "undefined" || !("navigator" in window)) {
		return "windows";
	}
	const platform = (navigator.userAgentData?.platform || navigator.platform)?.toLowerCase();

	if (platform.startsWith("win") || platform.startsWith("and")) {
		isOIS.value = true;
	}
	if (platform.startsWith("mac") || platform.startsWith("ip")) {
		isOIS.value = false;
	}
	if (platform.startsWith("ip")) {
		isIphone.value = true;
	}
	if (platform.startsWith("linux") || platform.startsWith("and")) {
		isOIS.value = true;
	}
	return "windows";
};
getAgentSystem();

export const scrollToSection = (id) => {
	const storeScroll = useScrollStore();
	const headerOffset = storeScroll.isProfilePage ? storeScroll.header?.offsetHeight * 2 : storeScroll.header?.offsetHeight || 100;
	const el = document.getElementById(id);

	if (el) {
		const elementPosition = el.getBoundingClientRect().top;
		const offsetPosition = elementPosition - headerOffset;
		window.scrollBy({
			top: offsetPosition - 20,
			behavior: "smooth",
		});
	}
};


export function debounce(func, delay) {
	let timeoutId;
	return function(...args) {
		clearTimeout(timeoutId);
			timeoutId = setTimeout(() => {
			func.apply(this, args);
		}, delay);
	};
}

export const declension = (n, forms) => {
    const num = Math.abs(parseInt(n)) % 100;
    const mod = num % 10;
    if (num > 10 && num < 20) return forms[2];
    if (mod > 1 && mod < 5) return forms[1];
    if (mod === 1) return forms[0];
    return forms[2];
};